export default __webpack_public_path__ + "static/media/teamgrp.0adf0019.png";